var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signin"},[_c('div',{staticClass:"header"},[_c('a-icon',{staticClass:"back",attrs:{"type":"left-circle"},on:{"click":function($event){return _vm.$router.go(-1)}}}),_c('div',{staticClass:"title"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('home.navTitles.signin')))])])],1),_c('Signin-Component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }